module.exports = __webpack_public_path__ + "img/txt_m.00a0e977.png";